import React from 'react';

import GridIcon from '@atlaskit/icon/core/grid';
import ListBulletedIcon from '@atlaskit/icon/core/list-bulleted';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { token } from '@atlaskit/tokens';

export interface QuickActionIconProps {
	quickActionId: string;
}

const getIcon = (id: string) => {
	const dataTestId = `${id}-quick-action-icon`;

	switch (id) {
		case 'ShowMore':
		case 'Table':
			return (
				<GridIcon
					spacing="spacious"
					testId={dataTestId}
					label=""
					color={token('color.icon.subtle')}
				/>
			);
		case 'TableOfContents':
			return (
				<ListBulletedIcon
					spacing="spacious"
					testId={dataTestId}
					label=""
					color={token('color.icon.subtle')}
				/>
			);
		case 'InfoPanel':
			return (
				<InformationCircleIcon
					spacing="spacious"
					testId={dataTestId}
					label=""
					color={token('color.icon.subtle')}
				/>
			);
		case 'Brainstorm':
			return (
				<AtlassianIntelligenceIcon
					spacing="spacious"
					testId={dataTestId}
					label=""
					color={token('color.icon.subtle')}
				/>
			);
		default:
			return null;
	}
};

export const QuickActionIcon = ({ quickActionId }: QuickActionIconProps) => {
	return getIcon(quickActionId);
};
